function setAnalytics(type) {
  sessionStorage.setItem(`analytics:${type}`, 'true');
}

export default setAnalytics;